const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const PoisonerCondition = require('../../conditions/PoisonerCondition');
const { logError } = require('../../logger');

const PoisonWeapon = function(battleState) {
  this.handle = 'poison_weapon';
  this.weapon = true;
  this.physical = true;
  this.magic = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    if (!victim || !victim.unit) {
      return false;
    }

    // victim must have a weapon equipped (weapon in right hand, or bow in left hand)
    const hasWeapon = victim.equipment.weapon ||
                      (victim.equipment.off_hand && victim.equipment.off_hand.type === 'bow');

    return hasWeapon;
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return { success: false };
    }

    try {
      var ability = BattleCalc.getEquippedAbility(actor, this.handle);

      const poisoner = new PoisonerCondition(
        actor,
        victim,
        battleState,
        ability.potency,
        ability.charges,
      );
      poisoner.actorId = actor.uid;
      poisoner.victimId = victim.uid;

      battleState.onUnitCondition(poisoner);

      var result = { poisoner };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim.uid;
      result.allPieces = battleState.allPieces;

      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'PoisonWeapon',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = PoisonWeapon;
